/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
import React, { ReactElement, useState } from 'react';
import { RenderSvg, Box } from 'components';
import { useTranslation } from 'react-i18next';
import './ErrorLoadData.scss';

/*
Toggle Switch Component
Note: id, checked and onChange are required for ToggleSwitch component to function.
The props name, small, disabled and optionLabels are optional.
Usage: <ToggleSwitch id={id} checked={value} onChange={checked => setValue(checked)}} />
*/

const ErrorLoadData = (): ReactElement => {
  const { t } = useTranslation('form');

  return (
    <Box noPadding id="formDataError" name={t('data.errorLoadDataTitle')}>
      <>{t('data.errorLoadDataContent')}</>
    </Box>
  );
};

export default ErrorLoadData;
